import type { ElementType, HTMLAttributeAnchorTarget, MouseEvent } from 'react';
import { forwardRef } from 'react';

import { LoadingButton, type LoadingButtonProps } from '@mui/lab';
import { IconButton } from '@mui/material';

// this is to fix TS issue: https://github.com/mui-org/material-ui/issues/15827
type ExtendedButtonProps = {
  component?: ElementType;
  target?: HTMLAttributeAnchorTarget;
} & LoadingButtonProps;

type ButtonWithAnalyticsProps = {
  eventName: string;
  eventProperties?: Record<string, unknown>;
} & ExtendedButtonProps;

/**
 * @deprecated PostHog Autocapture replaces the manual `data-action` tracking this wrapper added.
 * Use MUI `Button` (or `LoadingButton` for async actions) directly. Kept here only because there
 * are still a few legacy callers — please migrate when you touch one.
 */
export const AnalyticsButton = forwardRef<HTMLButtonElement, ButtonWithAnalyticsProps>(
  ({ eventName, eventProperties, onClick, ...buttonProps }, ref) => {
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
      if (onClick && typeof onClick === 'function') {
        onClick(e);
      }
    };

    return (
      <LoadingButton
        ref={ref}
        data-action={eventName}
        data-properties={eventProperties ? JSON.stringify(eventProperties) : undefined}
        onClick={handleClick}
        {...buttonProps}
      />
    );
  },
);

/**
 * @deprecated PostHog Autocapture replaces the manual `data-action` tracking this wrapper added.
 * Use MUI `IconButton` directly.
 */
export const AnalyticsIconButton = forwardRef<HTMLButtonElement, ButtonWithAnalyticsProps>(
  ({ eventName, eventProperties, onClick, ...buttonProps }, ref) => {
    const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
      if (onClick && typeof onClick === 'function') {
        onClick(e);
      }
    };

    return (
      <IconButton
        ref={ref}
        data-action={eventName}
        data-properties={eventProperties ? JSON.stringify(eventProperties) : undefined}
        onClick={handleClick}
        {...buttonProps}
      />
    );
  },
);
